import { IDealSourceData } from 'modules/core/types/dealSource';

export const isDealSourceVehicleInfoMissing = (
  isDealSourceVehicle: unknown,
  vin: string | undefined,
  dealSourceData?: IDealSourceData,
): boolean =>
  Boolean(
    isDealSourceVehicle &&
      dealSourceData?.manually_created &&
      (!vin || !dealSourceData?.sale_vehicle?.retail_price || !dealSourceData?.sale_vehicle?.book_value),
  );
